import React from "react";
import { useTable, Column } from "react-table";
import Loader from "./Loader";

interface TableProps<T extends object> {
  columns: any[];
  data: T[];
  tableHead: string;
  type:string;
  loading: boolean
}

const Table = <T extends object>({ 
    columns, 
    data,
    tableHead,
    type,
    loading
}: TableProps<T>) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable<T>({ columns, data });

    const getMappedValue = (columnId: string, value: string) => {
      const mappings: Record<string, Record<string, string>> = {
        category: {
          "0": " ",
          "1": "EMI Loans",
          "2": "EWI Loans(ntb)",
          "3": "EWI Loans(etb)",
          "4": "Past Customers",
          "5": "EWI Loans",
        },
        releationType: {
          "0": " ",
          "1": "% Disbursed Amount",
          "2": "% Loan Count",
          "3": "New-to-Bank (NTB)",
          "4": "Existing-to-KPB",
          "5": "Past-KPB",
        },
        state: {
          "0": " ",
          "1": "Kerala",
          "2": "Tamil Nadu",
        },
        stateEntity: {
          "0": " ",
          "1": "# Loans",
          "2": "% Loans",
          "3": "Disb Amt",
          "4": "% Disb Amt",
        },
        subRelation: {
          "0": " ",
          "1": "New-to-KPB",
          "2": "Existing-to-KPB",
          "3": "Past-KPB",
        },
      };
    
      return mappings[columnId]?.[value] || value; // Return mapped value or original if no match
    };

    const getRowStyle = (row: any, baseStyle: React.CSSProperties, rowIndex: number) => {
      const hasCategoryZero = row.cells.some((cell: any) => {
        return (cell.column.id === "category" || cell.column.id === "state") && cell.value !== "0";
      });
      return {
        ...baseStyle,
        backgroundColor: hasCategoryZero
          ? "#e9ecef" // Light red if category === "0"
          : type === "1" && rowIndex % 2 === 1 // Apply striped background for even-indexed rows (0-based)
          ? "#e9ecef"
          : "inherit",
        color: type === "1" && rowIndex % 2 === 1 ? "#212529" : "inherit",
        // backgroundColor: hasCategoryZero ? "#e9ecef" : "inherit",
      };
    };

  return (
    <div>
      <h1 style={styles.tableHead}>{tableHead}</h1>
      {loading ? (
         <div className="d-flex justify-content-center align-items-center" style={{"minHeight": "50vh"}}>
          <Loader />
       </div>
      ) :
      data.length > 0 ? 
      <table className={`tableClass${type}`} {...getTableProps()} style={styles.table}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} style={styles.headerRow}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} style={styles.headerCell}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} style={getRowStyle(row, styles.bodyRow, rowIndex)}>
                {row.cells.map((cell) => {
                  const cellValue = getMappedValue(cell.column.id, cell.value);

                  return (
                    <td {...cell.getCellProps()} style={styles.bodyCell}>
                      {cell.render("Cell", { value: cellValue })}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table> : 
        <p>No data available for the selected criteria</p>
      }
    </div>
  );
};

const styles: any = {
  table: { width: "100%", borderCollapse: "collapse", margin: "20px", overFlow: "scroll" },
  headerRow: { background: "#778da9", color: "#fff" },
  headerCell: { padding: "10px", textAlign: "center", fontSize: "small", whiteSpace: "nowrap" },
  bodyRow: { borderBottom: "1px solid #ddd" },
  bodyCell: { padding: "10px", textAlign: "center", fontSize: "small", whiteSpace: "nowrap" },
  tableHead: { fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}
};

export default Table;
